import { PageFlip } from 'page-flip';

export default {
  //bookClass: '.storybook',

  _bindEvents() {

    this.flipbook.on('flip', (e) => {
      const frontCoverIndex = 0;
      const backCoverIndex = this.flipbook.getPageCount() - 1;
      const index = parseInt(e.data);

      if ( index == frontCoverIndex ) {
        this.bookWrapper.setAttribute('data-book-state', 'front');
      } else if ( index == backCoverIndex ) {
        this.bookWrapper.setAttribute('data-book-state', 'back');
      } else {
        this.bookWrapper.setAttribute('data-book-state', 'open');
      }
    });
  },

  init() {
    this.bookElement = document.getElementById('storybook');
    if ( ! this.bookElement ) return;
    this.bookWrapper = this.bookElement.closest('.storybook-wrapper');
    if ( ! this.bookWrapper ) return;


    this.flipbook = new PageFlip(this.bookElement, {
      width: this.bookElement.dataset.pageWidth, // base page width
      height: this.bookElement.dataset.pageHeight, // base page height

      size: "stretch", // or "fixed"
      // set threshold values:
      minWidth: this.bookElement.dataset.pageMinWidth,
      minHeight: this.bookElement.dataset.pageMinHeight,
      maxWidth: this.bookElement.dataset.pageMaxWidth,
      maxHeight: this.bookElement.dataset.pageMaxHeight,

      maxShadowOpacity: 0.2, // Half shadow intensity
      showCover: true,
    });

    this.flipbook.loadFromHTML(document.querySelectorAll('.storybook__page'));

    if ( this.flipbook.getCurrentPageIndex() == 0 ) {
      this.bookWrapper.setAttribute('data-book-state', 'front');
    }

    this._bindEvents();

    const startPage = parseInt(this.bookElement.dataset.startPage);

    if ( startPage ) {
      this.flipbook.turnToPage(startPage);
    }
  },
}
